import supabase from "~/utils/supabaseClient";

export interface AnnouncementContent {
  title?: string;
  discount?: string;
  description?: string;
  
}

export interface Announcement {
  id: string;
  branch_id: string;
  type: "sale" | "gift" | "event" | "info";
  media_type?: "image" | "video" | "text";
  media_url?: string;
  ar?: {
    content?: AnnouncementContent;
    media_type?: string;
    type?: string;
    media_url?: string;
  };
  content: AnnouncementContent;
  start_at: string;
  end_at: string;
  priority: number;
  is_active: boolean;
  created_at: string;
}

export interface GetAnnouncementsPayload {
  branch_id: string;
  type?: string;
  is_active?: boolean;
  start_at?: string;
  end_at?: string;
  limit?: number;
  offset?: number;
  disable_pagination?: boolean;
}

export interface AnnouncementResponse {
  success: boolean;
  message: string;
  total_count?: number;
  data?: Announcement[];
}

export const getAnnouncements = async (
  payload: GetAnnouncementsPayload
): Promise<AnnouncementResponse> => {
  try {
    console.log("Calling get_announcements with payload:", payload);
    
    // @ts-ignore - RPC function not yet in generated types
    const { data, error } = await supabase.rpc("get_announcements", {
      payload: payload as any,
    });

    console.log("Supabase RPC response:", { data, error });

    if (error) {
      console.error("Supabase error:", error);
      throw error;
    }

    // The RPC returns the response object directly
    const response = data as unknown as AnnouncementResponse;
    console.log("Parsed response:", response);
    
    return response;
  } catch (error) {
    console.error("Error fetching announcements:", error);
    return {
      success: false,
      message: error instanceof Error ? error.message : "Failed to fetch announcements",
      data: [],
    };
  }
};

export const getDismissedAnnouncements = (): string[] => {
  const dismissed = localStorage.getItem("dismissedAnnouncements");
  return dismissed ? JSON.parse(dismissed) : [];
};

export const dismissAnnouncement = (announcementId: string): void => {
  const dismissed = getDismissedAnnouncements();
  if (!dismissed.includes(announcementId)) {
    dismissed.push(announcementId);
    localStorage.setItem("dismissedAnnouncements", JSON.stringify(dismissed));
  }
};

export const clearDismissedAnnouncements = (): void => {
  localStorage.removeItem("dismissedAnnouncements");
};
